module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP///////////////////////////////////////////////////////////////8/RimEAAAAQdFJOUwAvc+X3qcYOPNNeuwaTGEY+2hTfAAAAy0lEQVQ4y8WUSQ6DMBAE2/tu/P/Xxg6Logji5pCkThaUENPTACBa3T6ibUTHNALTn9coIiwnWmhO1Ggk3xTLIimxADky4tKzr4zou+jeMwmaEpNDVYwo8LLhEzEJn54H1y/5a1HlPr8iRHN071fiaLtYm9ex11MrgbqWWALr1m2FUCftUdsatN7vHodbNaM/hcCJAZITJTL1yNAzdWX+mmVkj5yF/4jI+D9uwmaZ6dTaDLcwOZa9evPfI5AYMQHcsuWYRqYwIckbET4AdMpLdG7QYK4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_01_zh.png
// module id = ya/5
// module chunks = 34